import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const DoubleChinPeriod = lazyWithPreload(
  () => import('./DoubleChinPeriod'),
)
